/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Auto_Rate_TitleInputs */

const en_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-set rate to match event duration, then render`)
};

const fr_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régler automatiquement le taux en fonction de la durée de l'événement, puis afficher`)
};

const de_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Anpassung der Rate an die Ereignisdauer, dann rendern`)
};

const it_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta automaticamente la frequenza in base alla durata dell'evento, quindi esegui il rendering.`)
};

const ru_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорость воспроизведения автоматически устанавливается в соответствии с продолжительностью события, затем выполняется рендеринг.`)
};

const es_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta automáticamente la velocidad para que coincida con la duración del evento y luego renderiza.`)
};

const zh_cn2_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动设置速率以匹配事件持续时间，然后渲染`)
};

const ja_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの継続時間に合わせてレートを自動設定し、レンダリングする。`)
};

const hi_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की अवधि के अनुसार दर स्वतः निर्धारित करें, फिर रेंडर करें`)
};

const pt_pt2_event_ad_auto_rate_title = /** @type {(inputs: Event_Ad_Auto_Rate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina automaticamente a taxa para corresponder à duração do evento e, em seguida, renderize.`)
};

/**
* | output |
* | --- |
* | "Auto-set rate to match event duration, then render" |
*
* @param {Event_Ad_Auto_Rate_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_auto_rate_title = /** @type {((inputs?: Event_Ad_Auto_Rate_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Auto_Rate_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_auto_rate_title(inputs)
	if (locale === "de") return de_event_ad_auto_rate_title(inputs)
	if (locale === "it") return it_event_ad_auto_rate_title(inputs)
	if (locale === "ru") return ru_event_ad_auto_rate_title(inputs)
	if (locale === "es") return es_event_ad_auto_rate_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_auto_rate_title(inputs)
	if (locale === "ja") return ja_event_ad_auto_rate_title(inputs)
	if (locale === "hi") return hi_event_ad_auto_rate_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_auto_rate_title(inputs)
	return en_event_ad_auto_rate_title(inputs)
});